import request from '@/utils/request'


// 查询树举报记录列表
export function listReport(query) {
  return request({
    url: '/tree/report/list',
    method: 'get',
    params: query
  })
}

// 查询树举报记录分页
export function pageReport(query) {
  return request({
    url: '/tree/report/page',
    method: 'get',
    params: query
  })
}

// 查询树举报记录详细
export function getReport(data) {
  return request({
    url: '/tree/report/detail',
    method: 'get',
    params: data
  })
}

// 新增树举报记录
export function addReport(data) {
  return request({
    url: '/tree/report/add',
    method: 'post',
    data: data
  })
}

// 修改树举报记录
export function updateReport(data) {
  return request({
    url: '/tree/report/edit',
    method: 'post',
    data: data
  })
}

// 删除树举报记录
export function delReport(data) {
  return request({
    url: '/tree/report/delete',
    method: 'post',
    data: data
  })
}
